import * as React from 'react';
import { connect } from 'react-redux';
import { MainState } from "../../../../Core/reducers";
import FailureWithMessage from '../../../../misc/components/FailureWithMessage';
import SuccessWithMessage from '../../../../misc/components/SuccessWithMessage';
import LoadingWithMessage from '../../../../misc/components/LoadingWithMessage';

export interface ReprocessCoughSessionCompletionProps extends ReprocessCoughSessionConfirmationStateProps, ReprocessCoughSessionConfirmationOwnProps {

}

interface ReprocessCoughSessionConfirmationStateProps {
    isFetching: boolean;
    error: string;

}

interface ReprocessCoughSessionConfirmationOwnProps {
    onCancel: () => void;
    nextText: string;
    backText: string;
    onNext: () => void;
}

export const ReprocessCoughSessionConfirmation = (props: ReprocessCoughSessionCompletionProps) => {
    const button = props.error ?
    <button className='btn btn-primary btn-outline' onClick={() => props.onCancel()}>{props.backText}</button>
    : <button disabled={props.isFetching || !!props.error} className='btn btn-primary' onClick={() => props.onNext()}>
            {props.nextText}
        </button>

    const content = props.isFetching ? <LoadingWithMessage message="Scheduling Session For Reprocessing." /> : props.error ? <FailureWithMessage message={props.error}></FailureWithMessage> : <SuccessWithMessage message="Session Successfully Scheduled For Reprocessing."></SuccessWithMessage>;

    return <div>

        <div className='modal-body'>
            {content}
        </div>
        <div className='modal-footer'>
            {button}               
        </div>
    </div>
}


function mapStateToProps(state: MainState, ownProps: ReprocessCoughSessionConfirmationOwnProps): ReprocessCoughSessionCompletionProps {
    return {
        isFetching: state.coughSessionsList.reprocessCoughSessionModal.isFetching,
        error: state.coughSessionsList.reprocessCoughSessionModal.error,
        backText: ownProps.backText,
        nextText: ownProps.nextText,
        onCancel: ownProps.onCancel,
        onNext: ownProps.onNext
    };
}

export default connect(mapStateToProps)(ReprocessCoughSessionConfirmation);
